import React, { Component } from 'react'
import RestApiUtils from '../../../../apiclient/moebli/RestApiUtils.js'
import MasterTemplateTermUI from './MasterTemplateTermUI.js'

class MasterTemplateTermSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      errorList: null,
      //
      value: this.props.templateTerm.templateValueList && this.props.templateTerm.templateValueList[this.props.templateTerm.templateValueList.length - 1].value || '',
      error: null,
      //
      editMode: false,
      devEditMode: false,
      //
      editSubmitted: false,
      generateSubmitted: false,
      createSubmitted: false
    }
  }

  render() {
    return (
      <MasterTemplateTermUI
        context={this.props.context}
        errorList={this.state.errorList}
        loan={this.props.loan}
        title={this.props.title}
        templateTerm={this.props.templateTerm}
        onRefreshClick={this.props.onRefreshClick}
        //
        value={this.state.value}
        onChange={(event) => this.setState({ value: event.target.value })}
        error={this.state.error}
        setError={(error) => this.setState({ error: error })}
        //
        editMode={this.state.editMode}
        onEditClick={this.onEditClick}
        //
        devEditMode={this.state.devEditMode}
        onDevEditClick={this.onDevEditClick}
        //
        editSubmitted={this.state.editSubmitted}
        onUpdateCurrentVersionClick={this.onUpdateCurrentVersionClick}
        createSubmitted={this.state.createSubmitted}
        onCreateNewVersionClick={this.onCreateNewVersionClick}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
  }

  onEditClick = () => {
    this.setState(prevState => ({
      editMode: !prevState.editMode,
      devEditMode: false
    }));
  }

  onDevEditClick = () => {
    this.setState(prevState => ({
      devEditMode: !prevState.devEditMode,
      editMode: false
    }));
  }

  onUpdateCurrentVersionClick = () => {
    let editSubmitted = this.state.editSubmitted
    if (editSubmitted)
      return

    let loanId = this.props.loan === undefined ? null : this.props.loan.loanId
    let apiPath = loanId === null 
      ? `/api/su/master/templates/${this.props.templateTerm.templateId}`
      : `/api/su/loans/${loanId}/templates/${this.props.templateTerm.templateId}`
    
    this.setState({
      successMsg: null,
      errorList: [],
      editSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      apiPath,
      this.onUpdateCurrentVersionClickCallback, {
      templateValue: this.state.value,
    }
    )
  }

  onUpdateCurrentVersionClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      editSubmitted: false,
      editMode: false,
      devEditMode: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
      }, 10)
    }
  }

  onCreateNewVersionClick = () => {
    let createSubmitted = this.state.createSubmitted
    if (createSubmitted)
      return

    let loanId = this.props.loan === undefined ? null : this.props.loan.loanId
    let apiPath = loanId === null
      ? `/api/su/master/templates/${this.props.templateCode}/version`
      : `/api/su/loans/${loanId}/templates/${this.props.templateCode}/version`
    
    this.setState({
      successMsg: null,
      errorList: [],
      createSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      apiPath,
      this.onCreateNewVersionClickCallback, {
      templateValue: this.state.value,
    }
    )
  }

  onCreateNewVersionClickCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      createSubmitted: false,
      editMode: false,
      devEditMode: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onRefreshClick()
      }, 10)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default MasterTemplateTermSF